"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4370],{

/***/ 14692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ Toast_Toast; }
});

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Dimensions/index.js
var Dimensions = __webpack_require__(95998);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(20129);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@tamagui/helpers/dist/esm/index.mjs + 5 modules
var esm = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/@tamagui/stacks/dist/esm/ThemeableStack.mjs + 1 modules
var ThemeableStack = __webpack_require__(90099);
// EXTERNAL MODULE: ./node_modules/@tamagui/text/dist/esm/SizableText.mjs
var SizableText = __webpack_require__(18796);
// EXTERNAL MODULE: ./node_modules/@tamagui/use-controllable-state/dist/esm/useControllableState.mjs
var useControllableState = __webpack_require__(81430);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tamagui/toast/dist/esm/constants.mjs
var constants = __webpack_require__(20335);
// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs + 1 modules
var dist_esm = __webpack_require__(75425);
// EXTERNAL MODULE: ./node_modules/@tamagui/start-transition/dist/esm/index.mjs
var start_transition_dist_esm = __webpack_require__(28031);
// EXTERNAL MODULE: ./node_modules/@tamagui/portal/dist/esm/index.mjs + 2 modules
var portal_dist_esm = __webpack_require__(86660);
// EXTERNAL MODULE: ./node_modules/@tamagui/visually-hidden/dist/esm/VisuallyHidden.mjs
var VisuallyHidden = __webpack_require__(68648);
// EXTERNAL MODULE: ./node_modules/@tamagui/toast/dist/esm/ToastProvider.mjs + 2 modules
var ToastProvider = __webpack_require__(2263);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@tamagui/toast/dist/esm/ToastAnnounce.mjs








const ToastAnnounceExcludeFrame = (0,cjs.styled)(cjs.Stack, {
    name: "ToastAnnounceExclude"
  }),
  ToastAnnounceExclude = react.forwardRef((props, forwardedRef) => {
    const {
      altText,
      ...announceExcludeProps
    } = props;
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ToastAnnounceExcludeFrame, {
      "data-toast-announce-exclude": "",
      "data-toast-announce-alt": altText || void 0,
      ...announceExcludeProps,
      ref: forwardedRef
    });
  }),
  ToastAnnounce = props => {
    const {
        __scopeToast,
        children,
        ...announceProps
      } = props,
      context = (0,ToastProvider/* useToastProviderContext */.jz)(__scopeToast),
      [renderAnnounceText, setRenderAnnounceText] = react.useState(!1),
      [isAnnounced, setIsAnnounced] = react.useState(!1);
    return useNextFrame(() => {
      (0,start_transition_dist_esm/* startTransition */.L)(() => {
        setRenderAnnounceText(!0);
      });
    }), react.useEffect(() => {
      const timer = setTimeout(() => setIsAnnounced(!0), 1e3);
      return () => clearTimeout(timer);
    }, []), isAnnounced ? null : /* @__PURE__ */(0,jsx_runtime.jsx)(portal_dist_esm/* Portal */.h_, {
      asChild: !0,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(VisuallyHidden/* VisuallyHidden */.T, {
        ...announceProps,
        children: renderAnnounceText && /* @__PURE__ */(0,jsx_runtime.jsxs)(cjs.Text, {
          children: [context.label, " ", children]
        })
      })
    });
  };
function useNextFrame(callback = () => {}) {
  const fn = (0,cjs.useEvent)(callback);
  (0,dist_esm/* useIsomorphicLayoutEffect */.LI)(() => {
    let raf1 = 0,
      raf2 = 0;
    return raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(fn);
    }), () => {
      cancelAnimationFrame(raf1), cancelAnimationFrame(raf2);
    };
  }, [fn]);
}

//# sourceMappingURL=ToastAnnounce.mjs.map

// EXTERNAL MODULE: ./node_modules/@tamagui/use-presence/dist/esm/index.mjs + 2 modules
var use_presence_dist_esm = __webpack_require__(61360);
// EXTERNAL MODULE: ./node_modules/@tamagui/compose-refs/dist/esm/compose-refs.mjs
var compose_refs = __webpack_require__(94030);
// EXTERNAL MODULE: ./node_modules/@tamagui/dismissable/dist/esm/index.mjs + 3 modules
var dismissable_dist_esm = __webpack_require__(69438);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/PanResponder/index.js + 2 modules
var PanResponder = __webpack_require__(64645);
// EXTERNAL MODULE: ./node_modules/@tamagui/toast/dist/esm/ToastViewport.mjs + 1 modules
var ToastViewport = __webpack_require__(7797);
;// CONCATENATED MODULE: ./node_modules/@tamagui/toast/dist/esm/ToastImpl.mjs
/* provided dependency */ var process = __webpack_require__(34155);















const ToastImplFrame = (0,cjs.styled)(ThemeableStack/* ThemeableStack */.K, {
    name: "ToastImpl",
    focusable: !0,
    variants: {
      unstyled: {
        false: {
          focusStyle: {
            outlineStyle: "solid",
            outlineWidth: 2,
            outlineColor: "$outlineColor"
          },
          backgroundColor: "$color6",
          borderRadius: "$10",
          paddingHorizontal: "$5",
          paddingVertical: "$2",
          marginHorizontal: "auto",
          marginVertical: "$1"
        }
      }
    },
    defaultVariants: {
      unstyled: process.env.TAMAGUI_HEADLESS === "1"
    }
  }),
  {
    Provider: ToastInteractiveProvider,
    useStyledContext: useToastInteractiveContext
  } = (0,cjs.createStyledContext)({
    onClose() {}
  }),
  ToastImpl = react.forwardRef((props, forwardedRef) => {
    const {
        __scopeToast,
        type = "foreground",
        duration: durationProp,
        open,
        onClose,
        onEscapeKeyDown,
        onPause,
        onResume,
        onSwipeStart,
        onSwipeMove,
        onSwipeCancel,
        onSwipeEnd,
        viewportName = "default",
        ...toastProps
      } = props,
      isPresent = (0,use_presence_dist_esm/* useIsPresent */.hO)(),
      context = (0,ToastProvider/* useToastProviderContext */.jz)(__scopeToast),
      [node, setNode] = react.useState(null),
      composedRefs = (0,compose_refs/* useComposedRefs */.ex)(forwardedRef, node2 => setNode(node2)),
      duration = durationProp || context.duration,
      closeTimerStartTimeRef = react.useRef(0),
      closeTimerRemainingTimeRef = react.useRef(duration),
      closeTimerRef = react.useRef(0),
      {
        onToastAdd,
        onToastRemove
      } = context,
      viewport = react.useMemo(() => context.viewports[viewportName], [context.viewports, viewportName]),
      handleClose = (0,cjs.useEvent)(() => {
        isPresent && (dist_esm/* isWeb */.$L && node?.contains(document.activeElement) && viewport?.focus(), onClose());
      }),
      startTimer = react.useCallback(duration2 => {
        !duration2 || duration2 === Number.POSITIVE_INFINITY || (clearTimeout(closeTimerRef.current), closeTimerStartTimeRef.current = ( /* @__PURE__ */new Date()).getTime(), closeTimerRef.current = setTimeout(handleClose, duration2));
      }, [handleClose]),
      handleResume = react.useCallback(() => {
        startTimer(closeTimerRemainingTimeRef.current), onResume?.();
      }, [onResume, startTimer]),
      handlePause = react.useCallback(() => {
        const elapsedTime = ( /* @__PURE__ */new Date()).getTime() - closeTimerStartTimeRef.current;
        closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime, window.clearTimeout(closeTimerRef.current), onPause?.();
      }, [onPause]);
    react.useEffect(() => {
      if (dist_esm/* isWeb */.$L && viewport) return viewport.addEventListener(ToastViewport/* VIEWPORT_PAUSE */.hu, handlePause), viewport.addEventListener(ToastViewport/* VIEWPORT_RESUME */.AR, handleResume), () => {
        viewport.removeEventListener(ToastViewport/* VIEWPORT_PAUSE */.hu, handlePause), viewport.removeEventListener(ToastViewport/* VIEWPORT_RESUME */.AR, handleResume);
      };
    }, [viewport, duration, onPause, onResume, startTimer]), react.useEffect(() => {
      open && !context.isClosePausedRef.current && startTimer(duration);
    }, [open, duration, context.isClosePausedRef, startTimer]), react.useEffect(() => (onToastAdd(), () => onToastRemove()), [onToastAdd, onToastRemove]);
    const announceTextContent = react.useMemo(() => dist_esm/* isWeb */.$L && node ? getAnnounceTextContent(node) : null, [node]),
      isHorizontalSwipe = ["left", "right", "horizontal"].includes(context.swipeDirection),
      {
        animationDriver
      } = (0,cjs.useConfiguration)();
    if (!animationDriver) throw new Error("Must set animations in tamagui.config.ts");
    const {
        useAnimatedNumber,
        useAnimatedNumberStyle
      } = animationDriver,
      animatedNumber = useAnimatedNumber(0),
      AnimatedView = animationDriver.NumberView ?? animationDriver.View ?? cjs.Stack,
      animatedStyles = useAnimatedNumberStyle(animatedNumber, val => {
        "worklet";

        return {
          transform: [isHorizontalSwipe ? {
            translateX: val
          } : {
            translateY: val
          }]
        };
      }),
      panResponder = react.useMemo(() => PanResponder/* default.create */.Z.create({
        onMoveShouldSetPanResponder: (e, gesture) => shouldGrantGestureMove(context.swipeDirection, gesture) ? (onSwipeStart?.(e), !0) : !1,
        onPanResponderGrant: e => {
          dist_esm/* isWeb */.$L || handlePause?.();
        },
        onPanResponderMove: (e, gesture) => {
          const {
              x,
              y
            } = getGestureDistance(context.swipeDirection, gesture),
            delta = {
              x,
              y
            };
          animatedNumber.setValue(isHorizontalSwipe ? x : y, {
            type: "direct"
          }), isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold) && onSwipeEnd?.(e), onSwipeMove?.(e);
        },
        onPanResponderEnd: (e, {
          dx,
          dy
        }) => {
          isDeltaInDirection({
            x: dx,
            y: dy
          }, context.swipeDirection, context.swipeThreshold) || (dist_esm/* isWeb */.$L || handleResume?.(), onSwipeCancel?.(e), animatedNumber.setValue(0, {
            type: "spring"
          }));
        }
      }), [handlePause, handleResume]),
      themeName = (0,cjs.useThemeName)();
    return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [announceTextContent && /* @__PURE__ */(0,jsx_runtime.jsx)(ToastAnnounce, {
        __scopeToast,
        role: "status",
        "aria-live": type === "foreground" ? "assertive" : "polite",
        "aria-atomic": !0,
        children: announceTextContent
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(portal_dist_esm/* PortalItem */.b5, {
        hostName: viewportName ?? "default",
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastInteractiveProvider, {
          scope: __scopeToast,
          onClose: () => {
            handleClose();
          },
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(dismissable_dist_esm/* Dismissable */.XA, {
            onEscapeKeyDown: (0,esm/* composeEventHandlers */.Mj)(onEscapeKeyDown, () => {
              context.isFocusedToastEscapeKeyDownRef.current || handleClose(), context.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(cjs.Theme, {
              forceClassName: !0,
              name: themeName,
              children: /* @__PURE__ */(0,jsx_runtime.jsx)(AnimatedView, {
                ...panResponder?.panHandlers,
                style: [{
                  margin: "auto"
                }, animatedStyles],
                children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastProvider/* Collection.ItemSlot */.FE.ItemSlot, {
                  __scopeCollection: __scopeToast || constants/* TOAST_CONTEXT */.B,
                  children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastImplFrame, {
                    role: "status",
                    "aria-live": "off",
                    "aria-atomic": !0,
                    "data-state": open ? "open" : "closed",
                    "data-swipe-direction": context.swipeDirection,
                    pointerEvents: "auto",
                    touchAction: "none",
                    userSelect: "none",
                    ...toastProps,
                    ref: composedRefs,
                    ...(dist_esm/* isWeb */.$L && {
                      onKeyDown: (0,esm/* composeEventHandlers */.Mj)(props.onKeyDown, event => {
                        event.key === "Escape" && (onEscapeKeyDown?.(event), onEscapeKeyDown?.(event), event.defaultPrevented || (context.isFocusedToastEscapeKeyDownRef.current = !0, handleClose()));
                      })
                    })
                  })
                })
              })
            })
          })
        }, props.id)
      })]
    });
  });
ToastImpl.propTypes = {
  type(props) {
    if (props.type && !["foreground", "background"].includes(props.type)) {
      const error = `Invalid prop \`type\` supplied to \`${constants/* TOAST_NAME */.F}\`. Expected \`foreground | background\`.`;
      return new Error(error);
    }
    return null;
  }
};
const isDeltaInDirection = (delta, direction, threshold = 0) => {
  const deltaX = Math.abs(delta.x),
    deltaY = Math.abs(delta.y),
    isDeltaX = deltaX > deltaY;
  return direction === "left" || direction === "right" || direction === "horizontal" ? isDeltaX && deltaX > threshold : !isDeltaX && deltaY > threshold;
};
function getAnnounceTextContent(container) {
  if (!dist_esm/* isWeb */.$L) return "";
  const textContent = [];
  return Array.from(container.childNodes).forEach(node => {
    if (node.nodeType === node.TEXT_NODE && node.textContent && textContent.push(node.textContent), isHTMLElement(node)) {
      const isHidden = node.ariaHidden || node.hidden || node.style.display === "none",
        isExcluded = node.dataset.toastAnnounceExclude === "";
      if (!isHidden) if (isExcluded) {
        const altText = node.dataset.toastAnnounceAlt;
        altText && textContent.push(altText);
      } else textContent.push(...getAnnounceTextContent(node));
    }
  }), textContent;
}
function isHTMLElement(node) {
  return node.nodeType === node.ELEMENT_NODE;
}
const GESTURE_GRANT_THRESHOLD = 10,
  shouldGrantGestureMove = (dir, {
    dx,
    dy
  }) => (dir === "horizontal" || dir === "left") && dx < -GESTURE_GRANT_THRESHOLD || (dir === "horizontal" || dir === "right") && dx > GESTURE_GRANT_THRESHOLD || (dir === "vertical" || dir === "up") && dy > -GESTURE_GRANT_THRESHOLD || (dir === "vertical" || dir === "down") && dy < GESTURE_GRANT_THRESHOLD,
  getGestureDistance = (dir, {
    dx,
    dy
  }) => {
    let y = 0,
      x = 0;
    return dir === "horizontal" ? x = dx : dir === "left" ? x = Math.min(0, dx) : dir === "right" ? x = Math.max(0, dx) : dir === "vertical" ? y = dy : dir === "up" ? y = Math.min(0, dy) : dir === "down" && (y = Math.max(0, dy)), {
      x,
      y
    };
  };

//# sourceMappingURL=ToastImpl.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/toast/dist/esm/Toast.mjs
/* provided dependency */ var Toast_process = __webpack_require__(34155);













const TITLE_NAME = "ToastTitle",
  ToastTitle = (0,cjs.styled)(SizableText/* SizableText */.J, {
    name: TITLE_NAME,
    variants: {
      unstyled: {
        false: {
          color: "$color",
          size: "$4"
        }
      }
    },
    defaultVariants: {
      unstyled: Toast_process.env.TAMAGUI_HEADLESS === "1"
    }
  });
ToastTitle.displayName = TITLE_NAME;
const DESCRIPTION_NAME = "ToastDescription",
  ToastDescription = (0,cjs.styled)(SizableText/* SizableText */.J, {
    name: DESCRIPTION_NAME,
    variants: {
      unstyled: {
        false: {
          color: "$color11",
          size: "$1"
        }
      }
    },
    defaultVariants: {
      unstyled: Toast_process.env.TAMAGUI_HEADLESS === "1"
    }
  });
ToastDescription.displayName = DESCRIPTION_NAME;
const ACTION_NAME = "ToastAction",
  ToastAction = react.forwardRef((props, forwardedRef) => {
    const {
      altText,
      ...actionProps
    } = props;
    return altText ? /* @__PURE__ */(0,jsx_runtime.jsx)(ToastAnnounceExclude, {
      altText,
      asChild: !0,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastClose, {
        ...actionProps,
        ref: forwardedRef
      })
    }) : null;
  });
ToastAction.propTypes = {
  altText(props) {
    return props.altText ? null : new Error(`Missing prop \`altText\` expected on \`${ACTION_NAME}\``);
  }
};
ToastAction.displayName = ACTION_NAME;
const CLOSE_NAME = "ToastClose",
  ToastCloseFrame = (0,cjs.styled)(ThemeableStack/* ThemeableStack */.K, {
    name: CLOSE_NAME,
    tag: "button"
  }),
  ToastClose = react.forwardRef((props, forwardedRef) => {
    const {
        __scopeToast,
        ...closeProps
      } = props,
      interactiveContext = useToastInteractiveContext(__scopeToast);
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ToastAnnounceExclude, {
      asChild: !0,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastCloseFrame, {
        accessibilityLabel: "Dialog Close",
        ...closeProps,
        ref: forwardedRef,
        onPress: (0,esm/* composeEventHandlers */.Mj)(props.onPress, interactiveContext.onClose)
      })
    });
  });
ToastClose.displayName = CLOSE_NAME;
const ToastComponent = ToastImplFrame.styleable((props, forwardedRef) => {
  const {
      forceMount,
      open: openProp,
      defaultOpen,
      onOpenChange,
      ...toastProps
    } = props,
    [open, setOpen] = (0,useControllableState/* useControllableState */.T)({
      prop: openProp,
      defaultProp: defaultOpen ?? !0,
      onChange: onOpenChange,
      strategy: "most-recent-wins"
    }),
    id = react.useId(),
    onPause = (0,cjs.useEvent)(props.onPause),
    onResume = (0,cjs.useEvent)(props.onResume);
  return forceMount || open ? /* @__PURE__ */(0,jsx_runtime.jsx)(ToastImpl, {
    id,
    open,
    ...toastProps,
    ref: forwardedRef,
    onClose: () => setOpen(!1),
    onPause,
    onResume,
    onSwipeEnd: (0,esm/* composeEventHandlers */.Mj)(props.onSwipeEnd, event => {
      setOpen(!1);
    })
  }) : null;
});
ToastComponent.displayName = constants/* TOAST_NAME */.F;
const Toast = (0,esm/* withStaticProperties */.$e)(ToastComponent, {
  Title: ToastTitle,
  Description: ToastDescription,
  Action: ToastAction,
  Close: ToastClose
});

//# sourceMappingURL=Toast.mjs.map

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/tokens.js
var tokens = __webpack_require__(61274);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 3 modules
var IconButton = __webpack_require__(61532);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Toast/Toast.js









var toastTokens = Components/* tokens.toast */.T.toast, Toast_Toast = function(param) {
    var message = param.message, _duration = param.duration, duration = _duration === void 0 ? 3e3 : _duration, analyticsName = param.analyticsName, trackImpression = param.trackImpression, onOpenChange = param.onOpenChange, isOpen = param.isOpen, _isSuccess = param.isSuccess, isSuccess = _isSuccess === void 0 ? !1 : _isSuccess, _hasError = param.hasError, hasError = _hasError === void 0 ? !1 : _hasError, onClose = param.onClose;
    var handleToastOpenChange = function handleToastOpenChange(open) {
        open || (onClose === null || onClose === void 0 ? void 0 : onClose()), onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(open);
    };
    var ref = Dimensions/* default.get */.Z.get("window"), screenWidth = ref.width, width = screenWidth * 0.95;
    var getBackgroundColor = function() {
        return hasError ? toastTokens.color.background.error : isSuccess ? toastTokens.color.background.success : toastTokens.color.background.default;
    };
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Toast, {
        zIndex: 1e3,
        open: isOpen,
        onOpenChange: handleToastOpenChange,
        animation: toastTokens.animation.timing.default,
        enterStyle: {
            x: 0,
            y: toastTokens.animation.enterTransition.offset.start,
            opacity: (0,tokens/* getOpacityTokenValue */.vs)(toastTokens.animation.opacity.enter.start)
        },
        exitStyle: {
            x: 0,
            y: -(0,cjs.getTokenValue)(toastTokens.animation.exitTransition.end),
            opacity: (0,tokens/* getOpacityTokenValue */.vs)(toastTokens.animation.opacity.exit.end)
        },
        duration: duration,
        $largerThanSM: {
            borderRadius: toastTokens.radius.size.m,
            marginVertical: toastTokens.margin.topBottom.m,
            paddingVertical: toastTokens.padding.topBottom.m,
            paddingHorizontal: toastTokens.padding.leftRight.m
        },
        $largerThanMD: {
            borderRadius: toastTokens.radius.size.lAndXl,
            marginVertical: toastTokens.margin.topBottom.lAndXl,
            paddingVertical: toastTokens.padding.topBottom.lAndXl,
            paddingHorizontal: toastTokens.padding.leftRight.lAndXl
        },
        marginVertical: toastTokens.margin.topBottom.xsAndS,
        paddingVertical: toastTokens.padding.topBottom.xsAndS,
        paddingHorizontal: toastTokens.padding.leftRight.xsAndX,
        borderRadius: toastTokens.radius.size.sAndXs,
        backgroundColor: getBackgroundColor(),
        width: width,
        maxWidth: toastTokens.size.maxWidth,
        children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
            justifyContent: "space-between",
            analyticsName: "".concat(analyticsName, "-toast"),
            trackImpression: trackImpression,
            flexDirection: "row",
            alignItems: "center",
            children: [
                /* @__PURE__ */ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    tag: "span",
                    color: toastTokens.color.content.valueText.default,
                    typography: toastTokens.typography.valueText,
                    children: message
                }),
                /* @__PURE__ */ (0,jsx_runtime.jsx)(Toast.Close, {
                    asChild: !0,
                    children: /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* CloseButton */.PZ, {
                        analyticsName: "".concat(analyticsName, "-close"),
                        size: "small",
                        variant: "inverse"
                    })
                })
            ]
        })
    });
};



/***/ })

}]);